module.exports = __webpack_public_path__ + "static/store-8b6c52c1c8cac287a0f56f683451356e.png";